import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const Icon = ({
  size = 24,
  ...props
}, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-seed-icon": "true",
    "data-seed-icon-version": "0.0.10",
    width: size,
    height: size,
    ref,
    ...props,
    children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.93106 2.60286C7.47398 3.08276 7.49248 3.84233 7.97238 4.29941L16.06 12.0024L7.97245 19.7043C7.49251 20.1614 7.47396 20.921 7.93101 21.4009C8.38806 21.8808 9.14763 21.8994 9.62756 21.4423L18.6276 12.8715C18.8654 12.645 19 12.3309 19 12.0025C19 11.6741 18.8654 11.36 18.6276 11.1335L9.62762 2.56153C9.14771 2.10445 8.38814 2.12296 7.93106 2.60286Z",
        fill: "currentColor"
      }
    ) })
  }
);
const IconChevronRightFill = forwardRef(Icon);
export default IconChevronRightFill;
